'use client';

import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuRoot,
  DropdownMenuTrigger,
  Logo,
  NavButton,
  NavContent,
  NavEnd,
  NavIconButton,
  NavItems,
  NavLink,
  NavRoot,
  NavStart,
} from '@pie/amber';
import { IconBookOpenText, IconHeadset, IconLogOut, IconUser } from '@pie/amber-icons';
import { SENSITIVE_CLASS_NAME } from '@upms/analytics';
import NextLink from 'next/link';
import { usePathname } from 'next/navigation';
import { env } from '@/config/env';
import { fullName, useIdentityContext } from '../IdentityContext';
import { useAuthContext } from '../AuthContext';

export const DesktopNavigation = () => {
  const { clearSession } = useAuthContext();
  const { user } = useIdentityContext();
  const path = usePathname();

  return (
    <NavRoot size="desktop" variant="insured">
      <NavContent>
        <NavStart>
          <Logo size="sm" />
          <NavItems>
            <NavLink as={NextLink} current={path === '/'} href="/">
              Home
            </NavLink>
            <NavLink as={NextLink} current={path.startsWith('/billing')} href="/billing">
              Billing and Payments
            </NavLink>
          </NavItems>
        </NavStart>
        <NavEnd>
          <NavItems>
            <NavIconButton as={NextLink} href="/resources" label="Resources" showTooltip>
              <IconBookOpenText />
            </NavIconButton>
            <NavIconButton as={NextLink} href="/support" label="Help & Support" showTooltip>
              <IconHeadset />
            </NavIconButton>
            <NavButton
              as="a"
              emphasis="medium"
              href={env.NEXT_PUBLIC_FILE_CLAIM_URL}
              rel="noopener noreferrer"
              target="_blank"
              tone="accent"
            >
              File a Claim
            </NavButton>
            <DropdownMenuRoot>
              <DropdownMenuTrigger>
                <NavButton className={SENSITIVE_CLASS_NAME} startIcon={<IconUser />}>
                  {fullName(user)}
                </NavButton>
              </DropdownMenuTrigger>
              <DropdownMenuContent side="bottom" align="end">
                <DropdownMenuItem
                  onClick={() => {
                    clearSession();
                  }}
                  icon={<IconLogOut />}
                >
                  Sign out
                </DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenuRoot>
          </NavItems>
        </NavEnd>
      </NavContent>
    </NavRoot>
  );
};
